module.exports = __webpack_public_path__ + "static/img/logo.eeed0dd2.png";